<template>
  <v-dialog
    v-bind="$attrs"
    v-model="dialog"
    :overlay="false"
    transition="dialog-transition"
    max-width="500"
    overlay-opacity="0.8"
  >
    <v-card max-width="500">
      <v-carousel
        hide-delimiter-background
        show-arrows-on-hover
        :height="!show ? '500px' : '250px'"
        style="max-height: 68vh"
      >
        <v-carousel-item v-for="(item, i) in [...produto.fotos]" :key="i">
          <v-img :src="item" height="100%" @click="() => ampliar(item)">
            <template v-slot:placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-progress-circular
                  indeterminate
                  color="grey lighten-5"
                ></v-progress-circular>
              </v-row>
            </template>
          </v-img>
          <v-btn
            v-if="['master', 'fornecedor'].includes($auth.user && $auth.user.tipo)"
            depressed
            fab
            small
            style="position: absolute; top: 12px; right: 12px; opacity: 0.6; font-size: 18px"
            >{{ getNumeroFoto(item) }}</v-btn
          >
        </v-carousel-item>
        <v-carousel-item
          v-if="produto && produto.video && produto.video.length > 0"
        >
          <video
            :src="produto.video[0]"
            height="100%"
            :width="$vuetify.breakpoint.xsOnly ? '100%' : 'auto'"
          />
          <v-btn
            v-if="!$vuetify.breakpoint.xsOnly"
            depressed
            fab
            x-large
            style="position: absolute; top: 42%; left: 50%; transform: translate(-50%); opacity: 0.6"
            @click="playVideo"
          >
            <v-icon size="48px">mdi-play</v-icon>
          </v-btn>
        </v-carousel-item>
      </v-carousel>
      <v-divider />

      <v-card-title class="pl-4 pt-4 pb-1 pr-1">
        <div
          :style="
            $auth.user && $auth.user.tipo === 'master'
              ? 'width: calc(100% - 160px); line-height: normal'
              : 'width: calc(100% - 52px); line-height: normal'
          "
        >
          {{ produto.descricao }}
          <v-card-subtitle class="pa-0"
            >Código - {{ produto.id
            }}{{
              $auth.user && !!$auth.user.tipo && $auth.user.tipo !== "cliente"
                ? ` [${produto.codigo}]`
                : ""
            }}</v-card-subtitle
          >
          <v-card-subtitle class="pa-0">
            <b>{{ produto.fornecedor && produto.fornecedor.nome_fantasia }}</b>
          </v-card-subtitle>
        </div>
        <v-btn
          v-if="
            (($auth.user && $auth.user.tipo === 'cliente') ||
              (!$auth.user || !$auth.user.tipo) ||
              ($auth.user.tipo === 'representante')) &&
              !rodada
          "
          icon
          large
          class="ml-2"
          primary
          @click="$refs.grade.abrir(produto)"
        >
          <v-icon>mdi-cart-plus</v-icon>
        </v-btn>
        <v-btn
          v-if="$auth.user && $auth.user.tipo === 'master'"
          fab
          depressed
          small
          color="red lighten-2"
          class="px-1 mr-2 ml-4 mb-auto"
          style="cursor: pointer"
          @click="reprovar"
        >
          <v-icon color="white">mdi-close</v-icon>
        </v-btn>
        <v-btn
          v-if="$auth.user && $auth.user.tipo === 'master'"
          fab
          depressed
          small
          color="green lighten-2"
          class="px-1 mb-auto mr-2"
          style="cursor: pointer"
          @click="aprovar"
        >
          <v-icon color="white">mdi-check</v-icon>
        </v-btn>

        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-if="$auth.user && $auth.user.tipo === 'master'"
              fab
              depressed
              small
              color="black lighten-2"
              style="cursor: pointer"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon color="white">mdi-pencil</v-icon>
            </v-btn>
          </template>
          <v-list dense>
            <v-list-item @click="abrirTelaEditarProduto">
              <v-list-item-title>
                <v-icon class="pr-4">shopping_cart</v-icon>Produto
              </v-list-item-title>
            </v-list-item>
            <v-list-item @click="abrirTelaEditarGaleria">
              <v-list-item-title>
                <v-icon class="pr-4">collections</v-icon>Fotos
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-card-title>

      <v-card-actions class="pl-4 pb-4">
        <v-chip
          label
          color="#FFD300"
          text-color="black"
          style="cursor: pointer"
        >
          <strong>R$ {{ produto.valor | valorBR }}</strong>
        </v-chip>

        <v-btn
          depressed
          class="ml-4"
          x-small
          fab
          dark
          color="blue"
          style="padding-left: 7px"
          @click.stop.prevent="compartilharLink"
        >
          <v-icon>mdi-share-variant</v-icon>
        </v-btn>
        <v-btn
          class="ml-2"
          depressed
          x-small
          fab
          dark
          color="green"
          @click="compartilharWhatsapp"
        >
          <v-icon>mdi-whatsapp</v-icon>
        </v-btn>
        <v-spacer></v-spacer>

        <small style="cursor: pointer" @click="show = !show"
          >Mais informações</small
        >

        <v-btn icon @click="show = !show">
          <v-icon>{{ show ? "mdi-chevron-up" : "mdi-chevron-down" }}</v-icon>
        </v-btn>
      </v-card-actions>

      <v-expand-transition>
        <div v-show="show">
          <v-divider></v-divider>

          <v-card-text class="py-0">
            <v-row>
              <v-col cols="6">
                <b>Tamanhos</b>
                <br />
                <label>{{ tamanhos }}</label>
              </v-col>
              <v-col cols="6">
                <b>Cores</b>
                <br />
                <label>{{ cores }}</label>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <b>Detalhes</b>
                <br />
                <label>{{ produto.detalhes }}</label>
              </v-col>
            </v-row>
          </v-card-text>
        </div>
      </v-expand-transition>
    </v-card>

    <grade
      ref="grade"
      :produto="produto"
      :fecharDetalhe="
        () => {
          dialog = false;
        }
      "
      idWindow="b"
    />

    <as-dialogo
      ref="dialogoVideo"
      :title="produto.descricao"
      max-width="1080px"
      :modal="false"
      @onFechar="videoClose"
      semPadding
    >
      <video
        width="100%"
        controls
        ref="video"
        style="margin-bottom: -8px"
        autoplay
      >
        <source :src="produto.video" type="video/mp4" />
      </video>
    </as-dialogo>

    <v-dialog
      v-model="dialogAmpliar"
      transition="dialog-transition"
      overlay-opacity="0.8"
      width="95vw"
    >
      <div
        :style="
          'position: relative; box-sizing: border-box;width: 100%; overflow: hidden; height: 90vh; background-size: cover; background-image: url(' +
            ampliarImagem +
            ')'
        "
        id="zoomImage"
      >
        <!-- <img
          id="zoomImage"
          style="height: auto; width: 100%"
          :src="ampliarImagem"
        /> -->
        <v-btn
          class="mx-2"
          fab
          dark
          small
          color="warning"
          style="position: absolute; top: 20px; right: 10px; z-index:101"
          @click="closeMagnify"
        >
          <v-icon dark>
            mdi-close
          </v-icon>
        </v-btn>
      </div>
    </v-dialog>

    <input type="hidden" id="input-link" :value="linkCompartilhamento" />
  </v-dialog>
</template>

<script>
import Grade from "./Grade.vue";
import ServiceProdutos from "@/services/produtos.js";

export default {
  name: "detalhe-produto",
  components: {
    Grade,
  },
  props: {
    produto: {
      type: Object,
    },
  },

  data() {
    return {
      dialog: false,
      show: false,
      rodada: JSON.parse(localStorage.getItem("rodada") || true),
      cores: "",
      tamanhos: "",
      dialogAmpliar: false,
      ampliarImagem: "",
      // origin: location.origin
    };
  },

  methods: {
    abrir() {
      this.show = false;
      this.dialog = true;
    },

    fechar() {
      this.dialog = false;
    },

    aprovar() {
      this.dialog = false;
      this.$emit("aprovar");
    },

    reprovar() {
      this.dialog = false;
      this.$emit("reprovar");
    },

    playVideo() {
      if (this.$refs.video) {
        this.$refs.video.play();
      }
      this.$refs.dialogoVideo.abrir();
    },

    videoClose() {
      this.$refs.video.pause();
      this.$refs.video.currentTime = 0;
    },

    getNumeroFoto(fileName) {
      if (fileName) {
        const fileNameArray = fileName.split("/");
        return fileNameArray[fileNameArray.length - 1].replace(/[^0-9]+/g, "");
      }
      return "";
    },

    compartilharLink() {
      let inputLinkToCopy = document.querySelector("#input-link");

      inputLinkToCopy.setAttribute("type", "text");
      inputLinkToCopy.select();
      document.execCommand("copy");
      inputLinkToCopy.setAttribute("type", "hidden");
      window.getSelection().removeAllRanges();

      this.$eventbus.notificar(
        "Link para compartilhamento copiado para a área de transferência"
      );
    },
    compartilharWhatsapp() {
      let texto = encodeURIComponent(
        "Olha que legal esse produto que eu achei lá no *NaModaComVc* \n\n _" +
          this.linkCompartilhamento +
          "_"
      );

      window.open("https://api.whatsapp.com/send?text=" + texto);
    },

    ampliar(src) {
      this.dialogAmpliar = true;
      this.ampliarImagem = src;
      document.body.addEventListener("keydown", this.ativarZoom);
      document.body.addEventListener("keyup", this.desativarZoom);

      setTimeout(() => {
        const el = document.getElementById("zoomImage");
        el.addEventListener("mousemove", (e) => {
          el.style.backgroundPositionY = (e.offsetY / 2) * -1 + "px";
        });
      }, 100);
    },

    ativarZoom(event) {
      if (event.key === "Control" && event.ctrlKey) {
        this.magnify();
      }
    },

    desativarZoom(event) {
      if (event.key === "Control" && !event.ctrlKey) {
        const glass = document.getElementById("glass");
        if (glass) glass.remove();
      }
    },

    closeMagnify() {
      this.dialogAmpliar = false;
      document.body.removeEventListener("keydown", this.ativarZoom);
      document.body.addEventListener("keyup", this.desativarZoom);
    },

    magnify() {
      const zoom = 3;
      let img, glass, w, h, bw;

      img = document.getElementById("zoomImage");

      glass = document.getElementById("glass");

      if (!glass) glass = document.createElement("div");
      glass.id = "glass";
      glass.setAttribute("class", "img-magnifier-glass");

      img.appendChild(glass);

      glass.style.backgroundImage = "url('" + this.ampliarImagem + "')";
      glass.style.backgroundRepeat = "no-repeat";
      glass.style.position = "absolute";
      glass.style.borderRadius = "50%";
      glass.style.height = "25vh";
      glass.style.width = "25vh";
      glass.style.borderRadius = "50%";
      glass.style.cursor = "none";
      glass.style.backgroundSize = glass.style.border = "3px solid white";
      glass.style.backgroundSize =
        img.width * zoom + "px " + img.height * zoom + "px";
      bw = 3;
      w = glass.offsetWidth / 2;
      h = glass.offsetHeight / 2;

      glass.addEventListener("mousemove", moveMagnifier);
      img.addEventListener("mousemove", moveMagnifier);

      glass.addEventListener("touchmove", moveMagnifier);
      img.addEventListener("touchmove", moveMagnifier);

      glass.dispatchEvent(new MouseEvent("mousemove"));

      function moveMagnifier(e) {
        let pos, x, y;
        e.preventDefault();
        pos = getCursorPos(e);

        x = pos.x;
        y = pos.y;

        if (x > img.width - w / zoom) {
          x = img.width - w / zoom;
        }
        if (x < w / zoom) {
          x = w / zoom;
        }
        if (y > img.height - h / zoom) {
          y = img.height - h / zoom;
        }
        if (y < h / zoom) {
          y = h / zoom;
        }
        glass.style.left = x - w + "px";
        glass.style.top = y - h + "px";
        glass.style.backgroundPosition =
          "-" + (x * zoom - w + bw) + "px -" + (y * zoom - h + bw) + "px";
      }

      function getCursorPos(e) {
        let a,
          x = 0,
          y = 0;
        e = e || window.event;
        a = img.getBoundingClientRect();
        x = e.pageX - a.left;
        y = e.pageY - a.top;
        x = x - window.pageXOffset;
        y = y - window.pageYOffset;
        return { x: x, y: y };
      }
    },

    abrirTelaEditarProduto() {
      let routeData = this.$router.resolve({name: '/produtos/adicionar'});

      window.open(routeData.href + 'produtos/' + this.produto.id + '/editar', '_blank');
    },
    abrirTelaEditarGaleria() {
      let routeData = this.$router.resolve({name: '/produtos/adicionar'});
      // let routeData = this.$router.resolve({name: `/produtos/${this.produto.id}/galeria`});

      window.open(routeData.href + 'produtos/' + this.produto.id + '/galeria', '_blank');
    }
  },
  computed: {
    linkCompartilhamento() {
      return location.origin + "/?shared=" + this.produto.id;
    },
  },
  watch: {
    produto: {
      handler: async function(value) {
        if (value) {
          const { data } = await ServiceProdutos.grade(this.produto.id);
          if (data) {
            this.cores = data.cores.map((item) => item.nome).join(", ");
            let i = this.cores.lastIndexOf(",");
            if (i >= 0) {
              this.cores =
                this.cores.substr(0, i) +
                " e " +
                this.cores.substr(i + 1, this.cores.length).trim();
            }
            this.tamanhos = data.tamanhos
              .map((item) => item.tamanho)
              .join(", ");
            i = this.tamanhos.lastIndexOf(",");
            if (i >= 0) {
              this.tamanhos =
                this.tamanhos.substr(0, i) +
                " e " +
                this.tamanhos.substr(i + 1, this.tamanhos.length).trim();
            }
          }
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.img-magnifier-glass {
  position: absolute;
  border: 3px solid #000;
  border-radius: 50%;
  cursor: none;
  width: 100px;
  height: 100px;
}
</style>
